<template>
  <div class="app-organizations">
    <div class="top">
      <p class="intro-text text-center">
        The Rubies COVID Charity Fund was set up to help provide food, monetary
        relief and other forms of support to Nigerians who are at risk during
        this time. <br />
        This fund supports several organizations.<br />
        <br />
        To become an organization send us a mail.
        <a
          href="mailto:donate@rubies.ng?&subject=I Want to Enlist as An NGO on donate.rubies.ng"
          >here</a
        >.
      </p>

      <div class="row">
        <div class="col-sm-6">
          <SocialShareModal />
        </div>
        <div class="col-sm-6">
          <DonateNowModal />
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="row">
        <div
          v-for="org in organization.organizations"
          :key="org.id"
          class="col-sm-4"
        >
          <OrgCard :organization="org" />
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>

<script>
import SocialShareModal from "../Modal/SocialShareModal";
import DonateNowModal from "../Modal/DonateNowModal";
import OrgCard from "../Cards/OrgCard";
import { mapState } from "vuex";

export default {
  name: "AppLanding",
  components: { SocialShareModal, DonateNowModal, OrgCard },
  computed: {
    ...mapState(["organization"])
  }
};
</script>
